export default {
    name: "",
    components: {},
    data() {
        return {
            pngList: [
                {
                    type: "单位换算",
                    list: {
                        面积单位换算: require("@/public/myformula/primary/单位换算/面积单位换算.png"),
                        人民币单位换算: require("@/public/myformula/primary/单位换算/人民币单位换算.png"),
                        时间单位换算: require("@/public/myformula/primary/单位换算/时间单位换算.png"),
                        体积单位换算: require("@/public/myformula/primary/单位换算/体积单位换算.png"),
                        长度单位换算: require("@/public/myformula/primary/单位换算/长度单位换算.png"),
                        重量单位换算: require("@/public/myformula/primary/单位换算/重量单位换算.png"),
                    },
                },
                {
                    type: "分数",
                    list: {
                        百分数的定义: require("@/public/myformula/primary/分数/百分数的定义.png"),
                        带分数的定义: require("@/public/myformula/primary/分数/带分数的定义.png"),
                        倒数: require("@/public/myformula/primary/分数/倒数.png"),
                        "分数乘法--分数乘分数": require("@/public/myformula/primary/分数/分数乘法--分数乘分数.png"),
                        "分数乘法--分数乘整数": require("@/public/myformula/primary/分数/分数乘法--分数乘整数.png"),
                        分数除法: require("@/public/myformula/primary/分数/分数除法.png"),
                        分数的定义: require("@/public/myformula/primary/分数/分数的定义.png"),
                        分数的加减法则: require("@/public/myformula/primary/分数/分数的加减法则.png"),
                        假分数的定义: require("@/public/myformula/primary/分数/假分数的定义.png"),
                        真分数的定义: require("@/public/myformula/primary/分数/真分数的定义.png"),
                    },
                },
                {
                    type: "几何图形计算",
                    list: {
                        平行四边形的面积: require("@/public/myformula/primary/几何图形计算/平行四边形的面积.png"),
                        梯形的面积: require("@/public/myformula/primary/几何图形计算/梯形的面积.png"),
                        已知三角形底和高求面积: require("@/public/myformula/primary/几何图形计算/已知三角形底和高求面积.png"),
                        已知三角形三边长求面积: require("@/public/myformula/primary/几何图形计算/已知三角形三边长求面积.png"),
                        圆的半径与直径的关系: require("@/public/myformula/primary/几何图形计算/圆的半径与直径的关系.png"),
                        圆的面积: require("@/public/myformula/primary/几何图形计算/圆的面积.png"),
                        圆的周长: require("@/public/myformula/primary/几何图形计算/圆的周长.png"),
                        圆柱的表面积: require("@/public/myformula/primary/几何图形计算/圆柱的表面积.png"),
                        圆柱的侧面积: require("@/public/myformula/primary/几何图形计算/圆柱的侧面积.png"),
                        圆柱的体积: require("@/public/myformula/primary/几何图形计算/圆柱的体积.png"),
                        圆锥侧面积: require("@/public/myformula/primary/几何图形计算/圆锥侧面积.png"),
                        圆锥的体积: require("@/public/myformula/primary/几何图形计算/圆锥的体积.png"),
                        长方体的体积: require("@/public/myformula/primary/几何图形计算/长方体的体积.png"),
                        长方形的面积: require("@/public/myformula/primary/几何图形计算/长方形的面积.png"),
                        长方形的周长: require("@/public/myformula/primary/几何图形计算/长方形的周长.png"),
                        正方体的体积: require("@/public/myformula/primary/几何图形计算/正方体的体积.png"),
                        正方形的面积: require("@/public/myformula/primary/几何图形计算/正方形的面积.png"),
                        正方形的周长: require("@/public/myformula/primary/几何图形计算/正方形的周长.png"),
                    },
                },
                {
                    type: "数量关系计算",
                    list: {
                        "1倍数、倍数、几倍数": require("@/public/myformula/primary/数量关系计算/1倍数、倍数、几倍数.png"),
                        "被除数、除数、商": require("@/public/myformula/primary/数量关系计算/被除数、除数、商.png"),
                        "被减数、减数、差": require("@/public/myformula/primary/数量关系计算/被减数、减数、差.png"),
                        "单价、数量、总价": require("@/public/myformula/primary/数量关系计算/单价、数量、总价.png"),
                        "工作效率、工作时间、工作总量": require("@/public/myformula/primary/数量关系计算/工作效率、工作时间、工作总量.png"),
                        "加数、和": require("@/public/myformula/primary/数量关系计算/加数、和.png"),
                        "每份数、份数、总数": require("@/public/myformula/primary/数量关系计算/每份数、份数、总数.png"),
                        "速度、时间、路程": require("@/public/myformula/primary/数量关系计算/速度、时间、路程.png"),
                        "因数、积": require("@/public/myformula/primary/数量关系计算/因数、积.png"),
                    },
                },
                {
                    type: "算术定律",
                    list: {
                        乘法分配律: require("@/public/myformula/primary/算术定律/乘法分配律.png"),
                        乘法交换律: require("@/public/myformula/primary/算术定律/乘法交换律.png"),
                        乘法结合律: require("@/public/myformula/primary/算术定律/乘法结合律.png"),
                        除法的性质: require("@/public/myformula/primary/算术定律/除法的性质.png"),
                        等式的性质1: require("@/public/myformula/primary/算术定律/等式的性质1.png"),
                        等式的性质2: require("@/public/myformula/primary/算术定律/等式的性质2.png"),
                        等式的性质3: require("@/public/myformula/primary/算术定律/等式的性质3.png"),
                        等式的性质4: require("@/public/myformula/primary/算术定律/等式的性质4.png"),
                        加法交换律: require("@/public/myformula/primary/算术定律/加法交换律.png"),
                        加法结合律: require("@/public/myformula/primary/算术定律/加法结合律.png"),
                        一元一次方程: require("@/public/myformula/primary/算术定律/一元一次方程.png"),
                    },
                },
                {
                    type: "应用题公式",
                    list: {
                        差倍问题: require("@/public/myformula/primary/应用题公式/差倍问题.png"),
                        得失问题: require("@/public/myformula/primary/应用题公式/得失问题.png"),
                        方阵问题: require("@/public/myformula/primary/应用题公式/方阵问题.png"),
                        分率问题: require("@/public/myformula/primary/应用题公式/分率问题.png"),
                        工程问题: require("@/public/myformula/primary/应用题公式/工程问题.png"),
                        行程问题: require("@/public/myformula/primary/应用题公式/行程问题.png"),
                        行船问题: require("@/public/myformula/primary/应用题公式/行船问题.png"),
                        和倍问题: require("@/public/myformula/primary/应用题公式/和倍问题.png"),
                        和差问题: require("@/public/myformula/primary/应用题公式/和差问题.png"),
                        "鸡兔问题--已知总脚数及鸡兔互换后总脚数": require("@/public/myformula/primary/应用题公式/鸡兔问题--已知总脚数及鸡兔互换后总脚数.png"),
                        "鸡兔问题--已知总头数和鸡兔脚数之差且鸡的总脚数比兔的多": require("@/public/myformula/primary/应用题公式/鸡兔问题--已知总头数和鸡兔脚数之差且鸡的总脚数比兔的多.png"),
                        "鸡兔问题--已知总头数和鸡兔脚数之差且兔的总脚数比鸡的多": require("@/public/myformula/primary/应用题公式/鸡兔问题--已知总头数和鸡兔脚数之差且兔的总脚数比鸡的多.png"),
                        "鸡兔问题--已知总头数和总脚": require("@/public/myformula/primary/应用题公式/鸡兔问题--已知总头数和总脚数.png"),
                        "利率问题--单利": require("@/public/myformula/primary/应用题公式/利率问题--单利.png"),
                        "利率问题--复利": require("@/public/myformula/primary/应用题公式/利率问题--复利.png"),
                        利润与折扣问题: require("@/public/myformula/primary/应用题公式/利润与折扣问题.png"),
                        列车过桥问题: require("@/public/myformula/primary/应用题公式/列车过桥问题.png"),
                        流水问题: require("@/public/myformula/primary/应用题公式/流水问题.png"),
                        浓度问题: require("@/public/myformula/primary/应用题公式/浓度问题.png"),
                        求比较数公式: require("@/public/myformula/primary/应用题公式/求比较数公式.png"),
                        求标准数公式: require("@/public/myformula/primary/应用题公式/求标准数公式.png"),
                        同向行程问题: require("@/public/myformula/primary/应用题公式/同向行程问题.png"),
                        相离问题: require("@/public/myformula/primary/应用题公式/相离问题.png"),
                        相遇问题: require("@/public/myformula/primary/应用题公式/相遇问题.png"),
                        "盈亏问题--两次都亏": require("@/public/myformula/primary/应用题公式/盈亏问题--两次都亏.png"),
                        "盈亏问题--两次都盈": require("@/public/myformula/primary/应用题公式/盈亏问题--两次都盈.png"),
                        "盈亏问题--一次亏、一次刚好分完": require("@/public/myformula/primary/应用题公式/盈亏问题--一次亏、一次刚好分完.png"),
                        "盈亏问题--一次盈、一次刚好分完": require("@/public/myformula/primary/应用题公式/盈亏问题--一次盈、一次刚好分完.png"),
                        "盈亏问题--一次盈、一次亏": require("@/public/myformula/primary/应用题公式/盈亏问题--一次盈、一次亏.png"),
                        增减分率互求公式: require("@/public/myformula/primary/应用题公式/增减分率互求公式.png"),
                        "植树问题--非封闭线路上且两端都不要植树": require("@/public/myformula/primary/应用题公式/植树问题--非封闭线路上且两端都不要植树.png"),
                        "植树问题--非封闭线路上且两端都要植树": require("@/public/myformula/primary/应用题公式/植树问题--非封闭线路上且两端都要植树.png"),
                        "植树问题--非封闭线路上且只有一端要植树": require("@/public/myformula/primary/应用题公式/植树问题--非封闭线路上且只有一端要植树.png"),
                        "植树问题--封闭线路上植树": require("@/public/myformula/primary/应用题公式/植树问题--封闭线路上植树.png"),
                    },
                },
                {
                    type: "乘法与因式分解",
                    list: {
                        分组分解法: require("@/public/myformula/middle/乘法与因式分解/分组分解法.png"),
                        立方差公式: require("@/public/myformula/middle/乘法与因式分解/立方差公式.png"),
                        立方和公式: require("@/public/myformula/middle/乘法与因式分解/立方和公式.png"),
                        两根式: require("@/public/myformula/middle/乘法与因式分解/两根式.png"),
                        平方差公式: require("@/public/myformula/middle/乘法与因式分解/平方差公式.png"),
                        三数平方和公式: require("@/public/myformula/middle/乘法与因式分解/三数平方和公式.png"),
                        三项立方和公式: require("@/public/myformula/middle/乘法与因式分解/三项立方和公式.png"),
                        十字相乘法: require("@/public/myformula/middle/乘法与因式分解/十字相乘法.png"),
                        完全立方公式: require("@/public/myformula/middle/乘法与因式分解/完全立方公式.png"),
                        完全平方公式: require("@/public/myformula/middle/乘法与因式分解/完全平方公式.png"),
                    },
                },
                {
                    type: "基础代数",
                    list: {
                        不同分母分式的加减: require("@/public/myformula/middle/基础代数/不同分母分式的加减.png"),
                        乘积的方根: require("@/public/myformula/middle/基础代数/乘积的方根.png"),
                        等比定理: require("@/public/myformula/middle/基础代数/等比定理.png"),
                        反比: require("@/public/myformula/middle/基础代数/反比.png"),
                        分比: require("@/public/myformula/middle/基础代数/分比.png"),
                        分式的乘方: require("@/public/myformula/middle/基础代数/分式的乘方.png"),
                        分式的方根: require("@/public/myformula/middle/基础代数/分式的方根.png"),
                        分式的开方: require("@/public/myformula/middle/基础代数/分式的开方.png"),
                        分式的相乘: require("@/public/myformula/middle/基础代数/分式的相乘.png"),
                        根式的乘方: require("@/public/myformula/middle/基础代数/根式的乘方.png"),
                        根式的定义: require("@/public/myformula/middle/基础代数/根式的定义.png"),
                        "根式的化简-1": require("@/public/myformula/middle/基础代数/根式的化简-1.png"),
                        "根式的化简-2": require("@/public/myformula/middle/基础代数/根式的化简-2.png"),
                        "根式的化简-3": require("@/public/myformula/middle/基础代数/根式的化简-3.png"),
                        "根式的化简-4": require("@/public/myformula/middle/基础代数/根式的化简-4.png"),
                        更比: require("@/public/myformula/middle/基础代数/更比.png"),
                        合比: require("@/public/myformula/middle/基础代数/合比.png"),
                        和分比: require("@/public/myformula/middle/基础代数/和分比.png"),
                        "交叉积、反比、更比、合比、分比、和分比": require("@/public/myformula/middle/基础代数/交叉积、反比、更比、合比、分比、和分比.png"),
                        交叉积: require("@/public/myformula/middle/基础代数/交叉积.png"),
                        同分母分式的加减: require("@/public/myformula/middle/基础代数/同分母分式的加减.png"),
                    },
                },
                {
                    type: "几何图形",
                    list: {
                        "勾股定理-毕达哥斯拉定理": require("@/public/myformula/middle/几何图形/勾股定理-毕达哥斯拉定理.png"),
                        弧长公式: require("@/public/myformula/middle/几何图形/弧长公式.png"),
                        平面坐标系两点距离公式: require("@/public/myformula/middle/几何图形/平面坐标系两点距离公式.png"),
                        球的表面积: require("@/public/myformula/middle/几何图形/球的表面积.png"),
                        球的体积: require("@/public/myformula/middle/几何图形/球的体积.png"),
                        扇形面积: require("@/public/myformula/middle/几何图形/扇形面积.png"),
                        斜棱柱的侧面积: require("@/public/myformula/middle/几何图形/斜棱柱的侧面积.png"),
                        斜棱柱体积: require("@/public/myformula/middle/几何图形/斜棱柱体积.png"),
                        已知三角形两边及夹角求面积: require("@/public/myformula/middle/几何图形/已知三角形两边及夹角求面积.png"),
                        圆台侧面积: require("@/public/myformula/middle/几何图形/圆台侧面积.png"),
                        圆台体积: require("@/public/myformula/middle/几何图形/圆台体积.png"),
                        正棱台侧面积: require("@/public/myformula/middle/几何图形/正棱台侧面积.png"),
                        正棱台体积: require("@/public/myformula/middle/几何图形/正棱台体积.png"),
                        正棱锥侧面积: require("@/public/myformula/middle/几何图形/正棱锥侧面积.png"),
                        正棱锥体积: require("@/public/myformula/middle/几何图形/正棱锥体积.png"),
                        直棱柱的侧面积: require("@/public/myformula/middle/几何图形/直棱柱的侧面积.png"),
                        直棱柱体积: require("@/public/myformula/middle/几何图形/直棱柱体积.png"),
                        直线与圆的位置关系: require("@/public/myformula/middle/几何图形/直线与圆的位置关系.png"),
                    },
                },
                {
                    type: "解析几何",
                    list: {
                        抛物线的标准方程1: require("@/public/myformula/middle/解析几何/抛物线的标准方程1.png"),
                        抛物线的标准方程2: require("@/public/myformula/middle/解析几何/抛物线的标准方程2.png"),
                        抛物线的标准方程3: require("@/public/myformula/middle/解析几何/抛物线的标准方程3.png"),
                        抛物线的标准方程4: require("@/public/myformula/middle/解析几何/抛物线的标准方程4.png"),
                        圆的标准方程: require("@/public/myformula/middle/解析几何/圆的标准方程.png"),
                        圆的一般方程: require("@/public/myformula/middle/解析几何/圆的一般方程.png"),
                    },
                },
                {
                    type: "三角不等式",
                    list: {
                        三角不等式1: require("@/public/myformula/middle/三角不等式/三角不等式1.png"),
                        三角不等式2: require("@/public/myformula/middle/三角不等式/三角不等式2.png"),
                        三角不等式3: require("@/public/myformula/middle/三角不等式/三角不等式3.png"),
                        三角不等式4: require("@/public/myformula/middle/三角不等式/三角不等式4.png"),
                        三角不等式5: require("@/public/myformula/middle/三角不等式/三角不等式5.png"),
                    },
                },
                {
                    type: "三角函数",
                    list: {
                        半角公式: require("@/public/myformula/middle/三角函数/半角公式.png"),
                        倍角公式: require("@/public/myformula/middle/三角函数/倍角公式.png"),
                        和差化积公式: require("@/public/myformula/middle/三角函数/和差化积公式.png"),
                        积化和差公式: require("@/public/myformula/middle/三角函数/积化和差公式.png"),
                        加法公式: require("@/public/myformula/middle/三角函数/加法公式.png"),
                        角度于弧度的换算: require("@/public/myformula/middle/三角函数/角度于弧度的换算.png"),
                        "万能公式 毕达哥斯拉恒等式": require("@/public/myformula/middle/三角函数/万能公式 毕达哥斯拉恒等式.png"),
                        "诱导公式-1": require("@/public/myformula/middle/三角函数/诱导公式-1.png"),
                        "诱导公式-2": require("@/public/myformula/middle/三角函数/诱导公式-2.png"),
                        "诱导公式-3": require("@/public/myformula/middle/三角函数/诱导公式-3.png"),
                        "诱导公式-4": require("@/public/myformula/middle/三角函数/诱导公式-4.png"),
                        "诱导公式-5": require("@/public/myformula/middle/三角函数/诱导公式-5.png"),
                        "诱导公式-6": require("@/public/myformula/middle/三角函数/诱导公式-6.png"),
                        "诱导公式-7": require("@/public/myformula/middle/三角函数/诱导公式-7.png"),
                        余弦定理: require("@/public/myformula/middle/三角函数/余弦定理.png"),
                        正弦定理: require("@/public/myformula/middle/三角函数/正弦定理.png"),
                    },
                },
                {
                    type: "基础数列",
                    list: {
                        标准差: require("@/public/myformula/middle/基础数列/标准差.png"),
                        方差: require("@/public/myformula/middle/基础数列/方差.png"),
                        加权平均数: require("@/public/myformula/middle/基础数列/加权平均数.png"),
                        平均数: require("@/public/myformula/middle/基础数列/平均数.png"),
                        数列前n项和1: require("@/public/myformula/middle/基础数列/数列前n项和1.png"),
                        数列前n项和2: require("@/public/myformula/middle/基础数列/数列前n项和2.png"),
                        数列前n项和3: require("@/public/myformula/middle/基础数列/数列前n项和3.png"),
                        数列前n项和4: require("@/public/myformula/middle/基础数列/数列前n项和4.png"),
                        数列前n项和5: require("@/public/myformula/middle/基础数列/数列前n项和5.png"),
                        数列前n项和6: require("@/public/myformula/middle/基础数列/数列前n项和6.png"),
                    },
                },
                {
                    type: "一元二次方程",
                    list: {
                        求解一元二次方程: require("@/public/myformula/middle/一元二次方程/求解一元二次方程.png"),
                        一元二次方程: require("@/public/myformula/middle/一元二次方程/一元二次方程.png"),
                    },
                },
                {
                    type: "不等式",
                    list: {
                        不等式的性质1: require("@/public/myformula/high/不等式/不等式的性质1.png"),
                        不等式的性质2: require("@/public/myformula/high/不等式/不等式的性质2.png"),
                        不等式的性质3: require("@/public/myformula/high/不等式/不等式的性质3.png"),
                        不等式的性质4: require("@/public/myformula/high/不等式/不等式的性质4.png"),
                        不等式的性质5: require("@/public/myformula/high/不等式/不等式的性质5.png"),
                        不等式的性质6: require("@/public/myformula/high/不等式/不等式的性质6.png"),
                        常用不等式1: require("@/public/myformula/high/不等式/常用不等式1.png"),
                        常用不等式2: require("@/public/myformula/high/不等式/常用不等式2.png"),
                        常用不等式3: require("@/public/myformula/high/不等式/常用不等式3.png"),
                        常用不等式4: require("@/public/myformula/high/不等式/常用不等式4.png"),
                        常用不等式5: require("@/public/myformula/high/不等式/常用不等式5.png"),
                        含有绝对值的不等式: require("@/public/myformula/high/不等式/含有绝对值的不等式.png"),
                        均值不等式: require("@/public/myformula/high/不等式/均值不等式.png"),
                        "均值不等式-几何平均数": require("@/public/myformula/high/不等式/均值不等式-几何平均数.png"),
                        "均值不等式-平方平均数": require("@/public/myformula/high/不等式/均值不等式-平方平均数.png"),
                        "均值不等式-算数平均数": require("@/public/myformula/high/不等式/均值不等式-算数平均数.png"),
                        "均值不等式-调和平均数": require("@/public/myformula/high/不等式/均值不等式-调和平均数.png"),
                        正弦余弦不等式1: require("@/public/myformula/high/不等式/三角不等式1.png"),
                        正弦余弦不等式2: require("@/public/myformula/high/不等式/三角不等式2.png"),
                        正弦余弦不等式3: require("@/public/myformula/high/不等式/三角不等式3.png"),
                        一元二次不等式: require("@/public/myformula/high/不等式/一元二次不等式.png"),
                    },
                },
                {
                    type: "初等函数",
                    list: {
                        "常用对数、自然对数之间的关系": require("@/public/myformula/high/初等函数/常用对数、自然对数之间的关系.png"),
                        常用对数: require("@/public/myformula/high/初等函数/常用对数.png"),
                        "对数函数定义、对数恒等式": require("@/public/myformula/high/初等函数/对数函数定义、对数恒等式.png"),
                        对数函数定义: require("@/public/myformula/high/初等函数/对数函数定义.png"),
                        对数恒等式: require("@/public/myformula/high/初等函数/对数恒等式.png"),
                        "对数换底公式-1": require("@/public/myformula/high/初等函数/对数换底公式-1.png"),
                        "对数换底公式-2": require("@/public/myformula/high/初等函数/对数换底公式-2.png"),
                        对数运算法则: require("@/public/myformula/high/初等函数/对数运算法则.png"),
                        反函数的定义: require("@/public/myformula/high/初等函数/反函数的定义.png"),
                        反函数的性质1: require("@/public/myformula/high/初等函数/反函数的性质1.png"),
                        反函数的性质2: require("@/public/myformula/high/初等函数/反函数的性质2.png"),
                        反函数的性质3: require("@/public/myformula/high/初等函数/反函数的性质3.png"),
                        反函数的性质4: require("@/public/myformula/high/初等函数/反函数的性质4.png"),
                        分式的指数: require("@/public/myformula/high/初等函数/分式的指数.png"),
                        负数指数: require("@/public/myformula/high/初等函数/负数指数.png"),
                        "幂函数-定义": require("@/public/myformula/high/初等函数/幂函数-定义.png"),
                        指数的乘法: require("@/public/myformula/high/初等函数/指数的乘法.png"),
                        指数的乘方: require("@/public/myformula/high/初等函数/指数的乘方.png"),
                        指数的除法: require("@/public/myformula/high/初等函数/指数的除法.png"),
                        指数的开方: require("@/public/myformula/high/初等函数/指数的开方.png"),
                        "指数函数定义、自然指数函数": require("@/public/myformula/high/初等函数/指数函数定义、自然指数函数.png"),
                        指数为零: require("@/public/myformula/high/初等函数/指数为零.png"),
                        自然对数: require("@/public/myformula/high/初等函数/自然对数.png"),
                    },
                },
                {
                    type: "导数",
                    list: {
                        导数的定义: require("@/public/myformula/high/导数/导数的定义.png"),
                        导数的记法: require("@/public/myformula/high/导数/导数的记法.png"),
                        导数的莱布尼兹记法: require("@/public/myformula/high/导数/导数的莱布尼兹记法.png"),
                        导数的牛顿记法: require("@/public/myformula/high/导数/导数的牛顿记法.png"),
                        反函数求导法则: require("@/public/myformula/high/导数/反函数求导法则.png"),
                        复合函数求导法则: require("@/public/myformula/high/导数/复合函数求导法则.png"),
                        和差积商求导法则: require("@/public/myformula/high/导数/和差积商求导法则.png"),
                        "基本导数-1": require("@/public/myformula/high/导数/基本导数-1.png"),
                        "基本导数-2": require("@/public/myformula/high/导数/基本导数-2.png"),
                        "基本导数-3": require("@/public/myformula/high/导数/基本导数-3.png"),
                        "基本导数-4": require("@/public/myformula/high/导数/基本导数-4.png"),
                    },
                },
                {
                    type: "方程",
                    list: {
                        卡尔丹公式: require("@/public/myformula/high/方程/卡尔丹公式.png"),
                        双曲线的标准方程: require("@/public/myformula/high/方程/双曲线的标准方程.png"),
                        椭圆的标准方程: require("@/public/myformula/high/方程/椭圆的标准方程.png"),
                        椭圆的参数方程: require("@/public/myformula/high/方程/椭圆的参数方程.png"),
                        椭圆的切线方程1: require("@/public/myformula/high/方程/椭圆的切线方程1.png"),
                        椭圆的切线方程2: require("@/public/myformula/high/方程/椭圆的切线方程2.png"),
                        椭圆的切线方程3: require("@/public/myformula/high/方程/椭圆的切线方程3.png"),
                        一元三次方程: require("@/public/myformula/high/方程/一元三次方程.png"),
                        圆的参数方程: require("@/public/myformula/high/方程/圆的参数方程.png"),
                        圆的直径式方程: require("@/public/myformula/high/方程/圆的直径式方程.png"),
                        "直线方程--点斜式": require("@/public/myformula/high/方程/直线方程--点斜式.png"),
                        "直线方程--截距式": require("@/public/myformula/high/方程/直线方程--截距式.png"),
                        "直线方程--两点式": require("@/public/myformula/high/方程/直线方程--两点式.png"),
                        "直线方程--两点式的推广": require("@/public/myformula/high/方程/直线方程--两点式的推广.png"),
                        "直线方程--斜截式": require("@/public/myformula/high/方程/直线方程--斜截式.png"),
                        "直线方程--一般式": require("@/public/myformula/high/方程/直线方程--一般式.png"),
                    },
                },
                {
                    type: "基础知识",
                    list: {
                        n次独立重复试验的概率: require("@/public/myformula/high/基础知识/n次独立重复试验的概率.png"),
                        超几何分布: require("@/public/myformula/high/基础知识/超几何分布.png"),
                        独立事件: require("@/public/myformula/high/基础知识/独立事件.png"),
                        二项分布: require("@/public/myformula/high/基础知识/二项分布.png"),
                        方差和标准差: require("@/public/myformula/high/基础知识/方差和标准差.png"),
                        "复数--乘法": require("@/public/myformula/high/基础知识/复数--乘法.png"),
                        "复数--除法": require("@/public/myformula/high/基础知识/复数--除法.png"),
                        "复数--纯虚数": require("@/public/myformula/high/基础知识/复数--纯虚数.png"),
                        "复数--定义": require("@/public/myformula/high/基础知识/复数--定义.png"),
                        "复数--共轭复数": require("@/public/myformula/high/基础知识/复数--共轭复数.png"),
                        "复数--几何意义": require("@/public/myformula/high/基础知识/复数--几何意义.png"),
                        "复数--加减法": require("@/public/myformula/high/基础知识/复数--加减法.png"),
                        "复数--相等": require("@/public/myformula/high/基础知识/复数--相等.png"),
                        "复数--虚数": require("@/public/myformula/high/基础知识/复数--虚数.png"),
                        "概率--对立性质": require("@/public/myformula/high/基础知识/概率--对立性质.png"),
                        "概率--互斥性质": require("@/public/myformula/high/基础知识/概率--互斥性质.png"),
                        "概率--基本性质": require("@/public/myformula/high/基础知识/概率--基本性质.png"),
                        "概率--计算公式": require("@/public/myformula/high/基础知识/概率--计算公式.png"),
                        "集合--并集": require("@/public/myformula/high/基础知识/集合--并集.png"),
                        "集合--补集": require("@/public/myformula/high/基础知识/集合--补集.png"),
                        "集合--集合相等的定义": require("@/public/myformula/high/基础知识/集合--集合相等的定义.png"),
                        "集合--交集": require("@/public/myformula/high/基础知识/集合--交集.png"),
                        "集合--运算1": require("@/public/myformula/high/基础知识/集合--运算1.png"),
                        "集合--运算2": require("@/public/myformula/high/基础知识/集合--运算2.png"),
                        "集合--运算3": require("@/public/myformula/high/基础知识/集合--运算3.png"),
                        "集合--真子集的定义": require("@/public/myformula/high/基础知识/集合--真子集的定义.png"),
                        "集合--子集的定义": require("@/public/myformula/high/基础知识/集合--子集的定义.png"),
                        "逻辑用语--必要条件": require("@/public/myformula/high/基础知识/逻辑用语--必要条件.png"),
                        "逻辑用语--充分条件": require("@/public/myformula/high/基础知识/逻辑用语--充分条件.png"),
                        "逻辑用语--充要条件": require("@/public/myformula/high/基础知识/逻辑用语--充要条件.png"),
                        "逻辑用语--逻辑非": require("@/public/myformula/high/基础知识/逻辑用语--逻辑非.png"),
                        "逻辑用语--逻辑或": require("@/public/myformula/high/基础知识/逻辑用语--逻辑或.png"),
                        "逻辑用语--逻辑且": require("@/public/myformula/high/基础知识/逻辑用语--逻辑且.png"),
                        "逻辑用语--四种命题": require("@/public/myformula/high/基础知识/逻辑用语--四种命题.png"),
                        数集: require("@/public/myformula/high/基础知识/数集.png"),
                        数学期望: require("@/public/myformula/high/基础知识/数学期望.png"),
                        随机变量及其分布列性质: require("@/public/myformula/high/基础知识/随机变量及其分布列性质.png"),
                        条件概率: require("@/public/myformula/high/基础知识/条件概率.png"),
                        "条件概率--性质": require("@/public/myformula/high/基础知识/条件概率--性质.png"),
                        正态分布: require("@/public/myformula/high/基础知识/正态分布.png"),
                    },
                },
                {
                    type: "数列",
                    list: {
                        "常数项级数-定义": require("@/public/myformula/high/数列/常数项级数-定义.png"),
                        等比级数: require("@/public/myformula/high/数列/等比级数.png"),
                        "等比数列--常用性质1": require("@/public/myformula/high/数列/等比数列--常用性质1.png"),
                        "等比数列--常用性质2": require("@/public/myformula/high/数列/等比数列--常用性质2.png"),
                        "等比数列--求和公式": require("@/public/myformula/high/数列/等比数列--求和公式.png"),
                        "等比数列--通项公式1": require("@/public/myformula/high/数列/等比数列--通项公式1.png"),
                        "等比数列--通项公式2": require("@/public/myformula/high/数列/等比数列--通项公式1.png"),
                        "等差数列-常用性质1": require("@/public/myformula/high/数列/等差数列-常用性质1.png"),
                        "等差数列-常用性质2": require("@/public/myformula/high/数列/等差数列-常用性质2.png"),
                        "等差数列-常用性质3": require("@/public/myformula/high/数列/等差数列-常用性质3.png"),
                        "等差数列-常用性质4": require("@/public/myformula/high/数列/等差数列-常用性质4.png"),
                        "等差数列-求和公式1": require("@/public/myformula/high/数列/等差数列-求和公式1.png"),
                        "等差数列-求和公式2": require("@/public/myformula/high/数列/等差数列-求和公式2.png"),
                        "等差数列-通项公式1": require("@/public/myformula/high/数列/等差数列-通项公式1.png"),
                        "等差数列-通项公式2": require("@/public/myformula/high/数列/等差数列-通项公式1.png"),
                        阶乘的定义: require("@/public/myformula/high/数列/阶乘的定义.png"),
                        全排列和选排列: require("@/public/myformula/high/数列/全排列和选排列.png"),
                        数列常用裂项方法1: require("@/public/myformula/high/数列/数列常用裂项方法1.png"),
                        数列常用裂项方法2: require("@/public/myformula/high/数列/数列常用裂项方法2.png"),
                        数列常用裂项方法3: require("@/public/myformula/high/数列/数列常用裂项方法3.png"),
                        数列常用裂项方法4: require("@/public/myformula/high/数列/数列常用裂项方法4.png"),
                        数列常用裂项方法5: require("@/public/myformula/high/数列/数列常用裂项方法5.png"),
                        数列常用裂项方法6: require("@/public/myformula/high/数列/数列常用裂项方法6.png"),
                        数列的求和公式1: require("@/public/myformula/high/数列/数列的求和公式1.png"),
                        数列的求和公式2: require("@/public/myformula/high/数列/数列的求和公式2.png"),
                        数列的通项公式: require("@/public/myformula/high/数列/数列的通项公式.png"),
                        组合: require("@/public/myformula/high/数列/组合.png"),
                        组合公式: require("@/public/myformula/high/数列/组合公式.png"),
                    },
                },
                {
                    type: "图形几何",
                    list: {
                        两直线平行: require("@/public/myformula/high/图形几何/两直线平行.png"),
                        面面垂直判定定理: require("@/public/myformula/high/图形几何/面面垂直判定定理.png"),
                        面面垂直性质定理: require("@/public/myformula/high/图形几何/面面垂直性质定理.png"),
                        面面平行判定定理: require("@/public/myformula/high/图形几何/面面平行判定定理.png"),
                        面面平行性质定理: require("@/public/myformula/high/图形几何/面面平行性质定理.png"),
                        判断直线在平面内: require("@/public/myformula/high/图形几何/判断直线在平面内.png"),
                        确定两平面的交线: require("@/public/myformula/high/图形几何/确定两平面的交线.png"),
                        确定平面: require("@/public/myformula/high/图形几何/确定平面.png"),
                        线面垂直判定定理: require("@/public/myformula/high/图形几何/线面垂直判定定理.png"),
                        线面垂直性质定理: require("@/public/myformula/high/图形几何/线面垂直性质定理.png"),
                        线面平行判定定理: require("@/public/myformula/high/图形几何/线面平行判定定理.png"),
                        线面平行性质定理: require("@/public/myformula/high/图形几何/线面平行性质定理.png"),
                    },
                },
                {
                    type: "向量",
                    list: {
                        "空间向量--点面距": require("@/public/myformula/high/向量/空间向量--点面距.png"),
                        "空间向量--点线距": require("@/public/myformula/high/向量/空间向量--点线距.png"),
                        "空间向量--共面定理": require("@/public/myformula/high/向量/空间向量--共面定理.png"),
                        "空间向量--共线定理": require("@/public/myformula/high/向量/空间向量--共线定理.png"),
                        "空间向量--基本定理": require("@/public/myformula/high/向量/空间向量--基本定理.png"),
                        "空间向量--两面角": require("@/public/myformula/high/向量/空间向量--两面角.png"),
                        "空间向量--线面角": require("@/public/myformula/high/向量/空间向量--线面角.png"),
                        "空间向量--线线角": require("@/public/myformula/high/向量/空间向量--线线角.png"),
                        两向量的夹角公式: require("@/public/myformula/high/向量/两向量的夹角公式.png"),
                        "实数与向量的积运算律--第二分配律": require("@/public/myformula/high/向量/实数与向量的积运算律--第二分配律.png"),
                        "实数与向量的积运算律--第一分配律": require("@/public/myformula/high/向量/实数与向量的积运算律--第一分配律.png"),
                        "实数与向量的积运算律--结合律": require("@/public/myformula/high/向量/实数与向量的积运算律--结合律.png"),
                        向量垂直: require("@/public/myformula/high/向量/向量垂直.png"),
                        向量的模: require("@/public/myformula/high/向量/向量的模.png"),
                        向量的数量积: require("@/public/myformula/high/向量/向量的数量积.png"),
                        "向量的坐标运算--加法": require("@/public/myformula/high/向量/向量的坐标运算--加法.png"),
                        "向量的坐标运算--减法": require("@/public/myformula/high/向量/向量的坐标运算--减法.png"),
                        "向量的坐标运算--数量积": require("@/public/myformula/high/向量/向量的坐标运算--数量积.png"),
                        "向量的坐标运算--与实数的积": require("@/public/myformula/high/向量/向量的坐标运算--与实数的积.png"),
                        向量平行: require("@/public/myformula/high/向量/向量平行.png"),
                        向量数量积运算的主要性质1: require("@/public/myformula/high/向量/向量数量积运算的主要性质1.png"),
                        向量数量积运算的主要性质2: require("@/public/myformula/high/向量/向量数量积运算的主要性质2.png"),
                    },
                },
                {
                    type: "常微分方程",
                    list: {
                        伯努利方程: require("@/public/myformula/university/常微分方程/伯努利方程.png"),
                        初值问题: require("@/public/myformula/university/常微分方程/初值问题.png"),
                        第二类可化为变量分离微分方程: require("@/public/myformula/university/常微分方程/第二类可化为变量分离微分方程.png"),
                        第一类可化为变量分离微分方程: require("@/public/myformula/university/常微分方程/第一类可化为变量分离微分方程.png"),
                        二阶常系数非齐次线性微分方程: require("@/public/myformula/university/常微分方程/二阶常系数非齐次线性微分方程.png"),
                        二阶常系数齐次线性微分方程: require("@/public/myformula/university/常微分方程/二阶常系数齐次线性微分方程.png"),
                        全微分方程: require("@/public/myformula/university/常微分方程/全微分方程.png"),
                        微分形式变量可分离方程: require("@/public/myformula/university/常微分方程/微分形式变量可分离方程.png"),
                        "微分形式一阶方程、通解": require("@/public/myformula/university/常微分方程/微分形式一阶方程、通解.png"),
                        显示变量可分离方程: require("@/public/myformula/university/常微分方程/显示变量可分离方程.png"),
                        显示方程: require("@/public/myformula/university/常微分方程/显示方程.png"),
                        一阶线性非齐次微分方程: require("@/public/myformula/university/常微分方程/一阶线性非齐次微分方程.png"),
                        一阶线性齐次微分方程: require("@/public/myformula/university/常微分方程/一阶线性齐次微分方程.png"),
                        隐式方程: require("@/public/myformula/university/常微分方程/隐式方程.png"),
                    },
                },
                {
                    type: "有理函数",
                    list: {
                        有理函数多项式: require("@/public/myformula/university/有理函数/有理函数多项式.png"),
                        有理整函数多项式: require("@/public/myformula/university/有理函数/有理整函数多项式.png"),
                    },
                },
                {
                    type: "代数",
                    list: {
                        伯努利不等式: require("@/public/myformula/university/代数/伯努利不等式.png"),
                        "不等式-1": require("@/public/myformula/university/代数/不等式-1.png"),
                        "不等式-2": require("@/public/myformula/university/代数/不等式-2.png"),
                        多项式定理: require("@/public/myformula/university/代数/多项式定理.png"),
                        二项式定理: require("@/public/myformula/university/代数/二项式定理.png"),
                        赫尔德不等式: require("@/public/myformula/university/代数/赫尔德不等式.png"),
                        阶乘有限和公式: require("@/public/myformula/university/代数/阶乘有限和公式.png"),
                        柯西不等式: require("@/public/myformula/university/代数/柯西不等式.png"),
                        闵科夫斯基不等式: require("@/public/myformula/university/代数/闵科夫斯基不等式.png"),
                        切比雪夫不等式: require("@/public/myformula/university/代数/切比雪夫不等式.png"),
                        三角形不等式: require("@/public/myformula/university/代数/三角形不等式.png"),
                        斯特林公式: require("@/public/myformula/university/代数/斯特林公式.png"),
                        算术平均值不大于均方根: require("@/public/myformula/university/代数/算术平均值不大于均方根.png"),
                        詹森不等式: require("@/public/myformula/university/代数/詹森不等式.png"),
                        正数的几何平均值不大于算数平均值: require("@/public/myformula/university/代数/正数的几何平均值不大于算数平均值.png"),
                        正数加权平均值不等关系: require("@/public/myformula/university/代数/正数加权平均值不等关系.png"),
                    },
                },
                {
                    type: "微积分",
                    list: {
                        "不定积分 1": require("@/public/myformula/university/微积分/不定积分 1.png"),
                        "不定积分 2": require("@/public/myformula/university/微积分/不定积分 2.png"),
                        "不定积分 3": require("@/public/myformula/university/微积分/不定积分 3.png"),
                        "不定积分 4": require("@/public/myformula/university/微积分/不定积分 4.png"),
                        "不定积分 5": require("@/public/myformula/university/微积分/不定积分 5.png"),
                        不定积分的性质: require("@/public/myformula/university/微积分/不定积分的性质.png"),
                        第一类曲线积分的性质: require("@/public/myformula/university/微积分/第一类曲线积分的性质.png"),
                        "定积分 1": require("@/public/myformula/university/微积分/定积分 1.png"),
                        "定积分 2": require("@/public/myformula/university/微积分/定积分 2.png"),
                        "定积分 3": require("@/public/myformula/university/微积分/定积分 3.png"),
                        "定积分 4": require("@/public/myformula/university/微积分/定积分 4.png"),
                        "定积分 5": require("@/public/myformula/university/微积分/定积分 5.png"),
                        "定积分 6": require("@/public/myformula/university/微积分/定积分 6.png"),
                        "定积分 7": require("@/public/myformula/university/微积分/定积分 7.png"),
                        "定积分 8": require("@/public/myformula/university/微积分/定积分 8.png"),
                        "定积分 9": require("@/public/myformula/university/微积分/定积分 9.png"),
                        "定积分 10": require("@/public/myformula/university/微积分/定积分 10.png"),
                        对弧长的曲线积分: require("@/public/myformula/university/微积分/对弧长的曲线积分.png"),
                        "二重积分的定义、计算": require("@/public/myformula/university/微积分/二重积分的定义、计算.png"),
                        "二重积分中值定理、二重积分换元法": require("@/public/myformula/university/微积分/二重积分中值定理、二重积分换元法.png"),
                        积分中值定理及其推广第一定理: require("@/public/myformula/university/微积分/积分中值定理及其推广第一定理.png"),
                        积分中值定理推广第二定理: require("@/public/myformula/university/微积分/积分中值定理推广第二定理.png"),
                        极限: require("@/public/myformula/university/微积分/极限.png"),
                        "洛必达法则-1": require("@/public/myformula/university/微积分/洛必达法则-1.png"),
                        "洛必达法则-2": require("@/public/myformula/university/微积分/洛必达法则-2.png"),
                        "牛顿-莱布尼兹公式": require("@/public/myformula/university/微积分/牛顿-莱布尼兹公式.png"),
                        "三重积分的定义、计算": require("@/public/myformula/university/微积分/三重积分的定义、计算.png"),
                        "泰勒公式、拉格朗日余项": require("@/public/myformula/university/微积分/泰勒公式、拉格朗日余项.png"),
                        微分法则: require("@/public/myformula/university/微积分/微分法则.png"),
                        微分形式不变性: require("@/public/myformula/university/微积分/微分形式不变性.png"),
                        "重积分性质 1": require("@/public/myformula/university/微积分/重积分性质 1.png"),
                        "重积分性质 2": require("@/public/myformula/university/微积分/重积分性质 2.png"),
                        "重积分性质 3": require("@/public/myformula/university/微积分/重积分性质 3.png"),
                        "重积分性质 4": require("@/public/myformula/university/微积分/重积分性质 4.png"),
                        "重积分性质 5": require("@/public/myformula/university/微积分/重积分性质 5.png"),
                    },
                },
                {
                    type: "无穷级数",
                    list: {
                        常用幂级数展开: require("@/public/myformula/university/无穷级数/常用幂级数展开.png"),
                        二项式展开: require("@/public/myformula/university/无穷级数/二项式展开.png"),
                        傅里叶级数: require("@/public/myformula/university/无穷级数/傅里叶级数.png"),
                        "幂级数-定义": require("@/public/myformula/university/无穷级数/幂级数-定义.png"),
                        欧拉公式: require("@/public/myformula/university/无穷级数/欧拉公式.png"),
                        "三角级数、三角函数的正交性": require("@/public/myformula/university/无穷级数/三角级数、三角函数的正交性.png"),
                        "三角级数-简谐振动": require("@/public/myformula/university/无穷级数/三角级数-简谐振动.png"),
                        "泰勒级数、麦克劳林级数": require("@/public/myformula/university/无穷级数/泰勒级数、麦克劳林级数.png"),
                        "正弦、余弦级数，傅里叶级数的复数形式": require("@/public/myformula/university/无穷级数/正弦、余弦级数，傅里叶级数的复数形式.png"),
                    },
                },
                {
                    type: "概率论",
                    list: {
                        贝叶斯公式: require("@/public/myformula/university/概率论/贝叶斯公式.png"),
                        超几何概率分布: require("@/public/myformula/university/概率论/超几何概率分布.png"),
                        独立性定理: require("@/public/myformula/university/概率论/独立性定理.png"),
                        概率的乘法公式: require("@/public/myformula/university/概率论/概率的乘法公式.png"),
                        "概率基本性质-1": require("@/public/myformula/university/概率论/概率基本性质-1.png"),
                        "概率基本性质-2": require("@/public/myformula/university/概率论/概率基本性质-2.png"),
                        "概率基本性质-3": require("@/public/myformula/university/概率论/概率基本性质-3.png"),
                        "概率性质-1": require("@/public/myformula/university/概率论/概率性质-1.png"),
                        "概率性质-2": require("@/public/myformula/university/概率论/概率性质-2.png"),
                        "概率性质-3": require("@/public/myformula/university/概率论/概率性质-3.png"),
                        "概率性质-4": require("@/public/myformula/university/概率论/概率性质-4.png"),
                        概率与频率的关系: require("@/public/myformula/university/概率论/概率与频率的关系.png"),
                        古典概型: require("@/public/myformula/university/概率论/古典概型.png"),
                        频率的定义: require("@/public/myformula/university/概率论/频率的定义.png"),
                        "频率性质-1": require("@/public/myformula/university/概率论/频率性质-1.png"),
                        "频率性质-2": require("@/public/myformula/university/概率论/频率性质-2.png"),
                        "频率性质-3": require("@/public/myformula/university/概率论/频率性质-3.png"),
                        全概率公式: require("@/public/myformula/university/概率论/全概率公式.png"),
                        三事件互相独立: require("@/public/myformula/university/概率论/三事件互相独立.png"),
                        "概率论-条件概率": require("@/public/myformula/university/概率论/条件概率.png"),
                    },
                },
                {
                    type: "线性代数",
                    list: {
                        m行n列矩阵: require("@/public/myformula/university/线性代数/m行n列矩阵.png"),
                        n阶方阵: require("@/public/myformula/university/线性代数/n阶方阵.png"),
                        乘法: require("@/public/myformula/university/线性代数/乘法.png"),
                        "对称矩阵、反对称矩阵": require("@/public/myformula/university/线性代数/对称矩阵、反对称矩阵.png"),
                        对角阵: require("@/public/myformula/university/线性代数/对角阵.png"),
                        加法: require("@/public/myformula/university/线性代数/加法.png"),
                        零阵: require("@/public/myformula/university/线性代数/零阵.png"),
                        数乘: require("@/public/myformula/university/线性代数/数乘.png"),
                        线性变化: require("@/public/myformula/university/线性代数/线性变化.png"),
                        线性代数方程组: require("@/public/myformula/university/线性代数/线性代数方程组.png"),
                        运算法则: require("@/public/myformula/university/线性代数/运算法则.png"),
                        转置: require("@/public/myformula/university/线性代数/转置.png"),
                    },
                },
                // {
                // 	type: "自定义公式-第一组",
                // 	list: {
                // 		第一组1: require("@/public/myformula/custom/customformula1/myformula_1.png"),
                // 		第一组2: require("@/public/myformula/custom/customformula1/myformula_2.png"),
                // 		第一组3: require("@/public/myformula/custom/customformula1/myformula_3.png"),
                // 		第一组4: require("@/public/myformula/custom/customformula1/myformula_4.png"),
                // 		第一组5: require("@/public/myformula/custom/customformula1/myformula_5.png"),
                // 		第一组6: require("@/public/myformula/custom/customformula1/请输入公式名.png")
                // 	}
                // },
                // {
                // 	type: "自定义公式-第二组",
                // 	list: {
                // 		第二组1: require("@/public/myformula/custom/customformula2/myformula_1.png"),
                // 		第二组2: require("@/public/myformula/custom/customformula2/myformula_2.png"),
                // 		第二组3: require("@/public/myformula/custom/customformula2/myformula_3.png"),
                // 		第二组4: require("@/public/myformula/custom/customformula2/myformula_4.png"),
                // 		第二组5: require("@/public/myformula/custom/customformula2/myformula_5.png"),
                // 		第二组6: require("@/public/myformula/custom/customformula2/myformula_6.png"),
                // 		第二组7: require("@/public/myformula/custom/customformula2/myformula_7.png")
                // 	}
                // },
                // {
                // 	type: "自定义公式-第三组",
                // 	list: {
                // 		第三组1: require("@/public/myformula/custom/customformula3/myformula_1.png"),
                // 		第三组2: require("@/public/myformula/custom/customformula3/myformula_2.png"),
                // 		第三组3: require("@/public/myformula/custom/customformula3/myformula_3.png"),
                // 		第三组4: require("@/public/myformula/custom/customformula3/myformula_4.png"),
                // 		第三组5: require("@/public/myformula/custom/customformula3/myformula_5.png")
                // 	}
                // },
                // {
                // 	type: "自定义公式-第四组",
                // 	list: {
                // 		第四组1: require("@/public/myformula/custom/customformula4/myformula_1.png"),
                // 		第四组2: require("@/public/myformula/custom/customformula4/myformula_2.png"),
                // 		第四组3: require("@/public/myformula/custom/customformula4/myformula_3.png"),
                // 		第四组4: require("@/public/myformula/custom/customformula4/myformula_4.png"),
                // 		第四组5: require("@/public/myformula/custom/customformula4/myformula_5.png")
                // 	}
                // },
                // {
                // 	type: "自定义公式-第五组",
                // 	list: {
                // 		第五组1: require("@/public/myformula/custom/customformula5/myformula_1.png"),
                // 		第五组2: require("@/public/myformula/custom/customformula5/myformula_2.png"),
                // 		第五组3: require("@/public/myformula/custom/customformula5/myformula_3.png"),
                // 		第五组4: require("@/public/myformula/custom/customformula5/myformula_4.png"),
                // 		第五组5: require("@/public/myformula/custom/customformula5/myformula_5.png"),
                // 		第五组6: require("@/public/myformula/custom/customformula5/myformula_6.png")
                // 	}
                // },
                // {
                // 	type: "自定义公式-第六组",
                // 	list: {
                // 		第六组1: require("@/public/myformula/custom/customformula6/myformulas_1.png"),
                // 		第六组2: require("@/public/myformula/custom/customformula6/myformula_2.png"),
                // 		第六组3: require("@/public/myformula/custom/customformula6/myformula_3.png"),
                // 		第六组4: require("@/public/myformula/custom/customformula6/myformula_4.png"),
                // 		第六组5: require("@/public/myformula/custom/customformula6/myformula_5.png"),
                // 		第六组6: require("@/public/myformula/custom/customformula6/myformula_6.png")
                // 	}
                // }
            ],
            mmlList: [
                [
                    "./myformula/primary/单位换算/面积单位换算.mml",
                    "./myformula/primary/单位换算/人民币单位换算.mml",
                    "./myformula/primary/单位换算/时间单位换算.mml",
                    "./myformula/primary/单位换算/体积单位换算.mml",
                    "./myformula/primary/单位换算/长度单位换算.mml",
                    "./myformula/primary/单位换算/重量单位换算.mml",
                ],
                [
                    "./myformula/primary/分数/百分数的定义.mml",
                    "./myformula/primary/分数/带分数的定义.mml",
                    "./myformula/primary/分数/倒数.mml",
                    "./myformula/primary/分数/分数乘法--分数乘分数.mml",
                    "./myformula/primary/分数/分数乘法--分数乘整数.mml",
                    "./myformula/primary/分数/分数除法.mml",
                    "./myformula/primary/分数/分数的定义.mml",
                    "./myformula/primary/分数/分数的加减法则.mml",
                    "./myformula/primary/分数/假分数的定义.mml",
                    "./myformula/primary/分数/真分数的定义.mml",
                ],
                [
                    "./myformula/primary/几何图形计算/平行四边形的面积.mml",
                    "./myformula/primary/几何图形计算/梯形的面积.mml",
                    "./myformula/primary/几何图形计算/已知三角形底和高求面积.mml",
                    "./myformula/primary/几何图形计算/已知三角形三边长求面积.mml",
                    "./myformula/primary/几何图形计算/圆的半径与直径的关系.mml",
                    "./myformula/primary/几何图形计算/圆的面积.mml",
                    "./myformula/primary/几何图形计算/圆的周长.mml",
                    "./myformula/primary/几何图形计算/圆柱的表面积.mml",
                    "./myformula/primary/几何图形计算/圆柱的侧面积.mml",
                    "./myformula/primary/几何图形计算/圆柱的体积.mml",
                    "./myformula/primary/几何图形计算/圆锥侧面积.mml",
                    "./myformula/primary/几何图形计算/圆锥的体积.mml",
                    "./myformula/primary/几何图形计算/长方体的体积.mml",
                    "./myformula/primary/几何图形计算/长方形的面积.mml",
                    "./myformula/primary/几何图形计算/长方形的周长.mml",
                    "./myformula/primary/几何图形计算/正方体的体积.mml",
                    "./myformula/primary/几何图形计算/正方形的面积.mml",
                    "./myformula/primary/几何图形计算/正方形的周长.mml",
                ],
                [
                    "./myformula/primary/数量关系计算/1倍数、倍数、几倍数.mml",
                    "./myformula/primary/数量关系计算/被除数、除数、商.mml",
                    "./myformula/primary/数量关系计算/被减数、减数、差.mml",
                    "./myformula/primary/数量关系计算/单价、数量、总价.mml",
                    "./myformula/primary/数量关系计算/工作效率、工作时间、工作总量.mml",
                    "./myformula/primary/数量关系计算/加数、和.mml",
                    "./myformula/primary/数量关系计算/每份数、份数、总数.mml",
                    "./myformula/primary/数量关系计算/速度、时间、路程.mml",
                    "./myformula/primary/数量关系计算/因数、积.mml",
                ],
                [
                    "./myformula/primary/算术定律/乘法分配律.mml",
                    "./myformula/primary/算术定律/乘法交换律.mml",
                    "./myformula/primary/算术定律/乘法结合律.mml",
                    "./myformula/primary/算术定律/除法的性质.mml",
                    "./myformula/primary/算术定律/等式的性质1.mml",
                    "./myformula/primary/算术定律/等式的性质2.mml",
                    "./myformula/primary/算术定律/等式的性质3.mml",
                    "./myformula/primary/算术定律/等式的性质4.mml",
                    "./myformula/primary/算术定律/加法交换律.mml",
                    "./myformula/primary/算术定律/加法结合律.mml",
                    "./myformula/primary/算术定律/一元一次方程.mml",
                ],
                [
                    "./myformula/primary/应用题公式/差倍问题.mml",
                    "./myformula/primary/应用题公式/得失问题.mml",
                    "./myformula/primary/应用题公式/方阵问题.mml",
                    "./myformula/primary/应用题公式/分率问题.mml",
                    "./myformula/primary/应用题公式/工程问题.mml",
                    "./myformula/primary/应用题公式/行程问题.mml",
                    "./myformula/primary/应用题公式/行船问题.mml",
                    "./myformula/primary/应用题公式/和倍问题.mml",
                    "./myformula/primary/应用题公式/和差问题.mml",
                    "./myformula/primary/应用题公式/鸡兔问题--已知总脚数及鸡兔互换后总脚数.mml",
                    "./myformula/primary/应用题公式/鸡兔问题--已知总头数和鸡兔脚数之差且鸡的总脚数比兔的多.mml",
                    "./myformula/primary/应用题公式/鸡兔问题--已知总头数和鸡兔脚数之差且兔的总脚数比鸡的多.mml",
                    "./myformula/primary/应用题公式/鸡兔问题--已知总头数和总脚数.mml",
                    "./myformula/primary/应用题公式/利率问题--单利.mml",
                    "./myformula/primary/应用题公式/利率问题--复利.mml",
                    "./myformula/primary/应用题公式/利润与折扣问题.mml",
                    "./myformula/primary/应用题公式/列车过桥问题.mml",
                    "./myformula/primary/应用题公式/流水问题.mml",
                    "./myformula/primary/应用题公式/浓度问题.mml",
                    "./myformula/primary/应用题公式/求比较数公式.mml",
                    "./myformula/primary/应用题公式/求标准数公式.mml",
                    "./myformula/primary/应用题公式/同向行程问题.mml",
                    "./myformula/primary/应用题公式/相离问题.mml",
                    "./myformula/primary/应用题公式/相遇问题.mml",
                    "./myformula/primary/应用题公式/盈亏问题--两次都亏.mml",
                    "./myformula/primary/应用题公式/盈亏问题--两次都盈.mml",
                    "./myformula/primary/应用题公式/盈亏问题--一次亏、一次刚好分完.mml",
                    "./myformula/primary/应用题公式/盈亏问题--一次盈、一次刚好分完.mml",
                    "./myformula/primary/应用题公式/盈亏问题--一次盈、一次亏.mml",
                    "./myformula/primary/应用题公式/增减分率互求公式.mml",
                    "./myformula/primary/应用题公式/植树问题--非封闭线路上且两端都不要植树.mml",
                    "./myformula/primary/应用题公式/植树问题--非封闭线路上且两端都要植树.mml",
                    "./myformula/primary/应用题公式/植树问题--非封闭线路上且只有一端要植树.mml",
                    "./myformula/primary/应用题公式/植树问题--封闭线路上植树.mml",
                ],
                [
                    "./myformula/middle/乘法与因式分解/分组分解法.mml",
                    "./myformula/middle/乘法与因式分解/立方差公式.mml",
                    "./myformula/middle/乘法与因式分解/立方和公式.mml",
                    "./myformula/middle/乘法与因式分解/两根式.mml",
                    "./myformula/middle/乘法与因式分解/平方差公式.mml",
                    "./myformula/middle/乘法与因式分解/三数平方和公式.mml",
                    "./myformula/middle/乘法与因式分解/三项立方和公式.mml",
                    "./myformula/middle/乘法与因式分解/十字相乘法.mml",
                    "./myformula/middle/乘法与因式分解/完全立方公式.mml",
                    "./myformula/middle/乘法与因式分解/完全平方公式.mml",
                ],
                [
                    "./myformula/middle/基础代数/不同分母分式的加减.mml",
                    "./myformula/middle/基础代数/乘积的方根.mml",
                    "./myformula/middle/基础代数/等比定理.mml",
                    "./myformula/middle/基础代数/反比.mml",
                    "./myformula/middle/基础代数/分比.mml",
                    "./myformula/middle/基础代数/分式的乘方.mml",
                    "./myformula/middle/基础代数/分式的方根.mml",
                    "./myformula/middle/基础代数/分式的开方.mml",
                    "./myformula/middle/基础代数/分式的相乘.mml",
                    "./myformula/middle/基础代数/根式的乘方.mml",
                    "./myformula/middle/基础代数/根式的定义.mml",
                    "./myformula/middle/基础代数/根式的化简-1.mml",
                    "./myformula/middle/基础代数/根式的化简-2.mml",
                    "./myformula/middle/基础代数/根式的化简-3.mml",
                    "./myformula/middle/基础代数/根式的化简-4.mml",
                    "./myformula/middle/基础代数/更比.mml",
                    "./myformula/middle/基础代数/合比.mml",
                    "./myformula/middle/基础代数/和分比.mml",
                    "./myformula/middle/基础代数/交叉积、反比、更比、合比、分比、和分比.mml",
                    "./myformula/middle/基础代数/交叉积.mml",
                    "./myformula/middle/基础代数/同分母分式的加减.mml",
                ],
                [
                    "./myformula/middle/几何图形/勾股定理-毕达哥斯拉定理.mml",
                    "./myformula/middle/几何图形/弧长公式.mml",
                    "./myformula/middle/几何图形/平面坐标系两点距离公式.mml",
                    "./myformula/middle/几何图形/球的表面积.mml",
                    "./myformula/middle/几何图形/球的体积.mml",
                    "./myformula/middle/几何图形/扇形面积.mml",
                    "./myformula/middle/几何图形/斜棱柱的侧面积.mml",
                    "./myformula/middle/几何图形/斜棱柱体积.mml",
                    "./myformula/middle/几何图形/已知三角形两边及夹角求面积.mml",
                    "./myformula/middle/几何图形/圆台侧面积.mml",
                    "./myformula/middle/几何图形/圆台体积.mml",
                    "./myformula/middle/几何图形/正棱台侧面积.mml",
                    "./myformula/middle/几何图形/正棱台体积.mml",
                    "./myformula/middle/几何图形/正棱锥侧面积.mml",
                    "./myformula/middle/几何图形/正棱锥体积.mml",
                    "./myformula/middle/几何图形/直棱柱的侧面积.mml",
                    "./myformula/middle/几何图形/直棱柱体积.mml",
                    "./myformula/middle/几何图形/直线与圆的位置关系.mml",
                ],
                [
                    "./myformula/middle/解析几何/抛物线的标准方程1.mml",
                    "./myformula/middle/解析几何/抛物线的标准方程2.mml",
                    "./myformula/middle/解析几何/抛物线的标准方程3.mml",
                    "./myformula/middle/解析几何/抛物线的标准方程4.mml",
                    "./myformula/middle/解析几何/圆的标准方程.mml",
                    "./myformula/middle/解析几何/圆的一般方程.mml",
                ],
                [
                    "./myformula/middle/三角不等式/三角不等式1.mml",
                    "./myformula/middle/三角不等式/三角不等式2.mml",
                    "./myformula/middle/三角不等式/三角不等式3.mml",
                    "./myformula/middle/三角不等式/三角不等式4.mml",
                    "./myformula/middle/三角不等式/三角不等式5.mml",
                ],
                [
                    "./myformula/middle/三角函数/半角公式.mml",
                    "./myformula/middle/三角函数/倍角公式.mml",
                    "./myformula/middle/三角函数/和差化积公式.mml",
                    "./myformula/middle/三角函数/积化和差公式.mml",
                    "./myformula/middle/三角函数/加法公式.mml",
                    "./myformula/middle/三角函数/角度于弧度的换算.mml",
                    "./myformula/middle/三角函数/万能公式 毕达哥斯拉恒等式.mml",
                    "./myformula/middle/三角函数/诱导公式-1.mml",
                    "./myformula/middle/三角函数/诱导公式-2.mml",
                    "./myformula/middle/三角函数/诱导公式-3.mml",
                    "./myformula/middle/三角函数/诱导公式-4.mml",
                    "./myformula/middle/三角函数/诱导公式-5.mml",
                    "./myformula/middle/三角函数/诱导公式-6.mml",
                    "./myformula/middle/三角函数/诱导公式-7.mml",
                    "./myformula/middle/三角函数/余弦定理.mml",
                    "./myformula/middle/三角函数/正弦定理.mml",
                ],
                [
                    "./myformula/middle/基础数列/标准差.mml",
                    "./myformula/middle/基础数列/方差.mml",
                    "./myformula/middle/基础数列/加权平均数.mml",
                    "./myformula/middle/基础数列/平均数.mml",
                    "./myformula/middle/基础数列/数列前n项和1.mml",
                    "./myformula/middle/基础数列/数列前n项和2.mml",
                    "./myformula/middle/基础数列/数列前n项和3.mml",
                    "./myformula/middle/基础数列/数列前n项和4.mml",
                    "./myformula/middle/基础数列/数列前n项和5.mml",
                    "./myformula/middle/基础数列/数列前n项和6.mml",
                ],
                ["./myformula/middle/一元二次方程/求解一元二次方程.mml", "./myformula/middle/一元二次方程/一元二次方程.mml"],
                [
                    "./myformula/high/不等式/不等式的性质1.mml",
                    "./myformula/high/不等式/不等式的性质2.mml",
                    "./myformula/high/不等式/不等式的性质3.mml",
                    "./myformula/high/不等式/不等式的性质4.mml",
                    "./myformula/high/不等式/不等式的性质5.mml",
                    "./myformula/high/不等式/不等式的性质6.mml",
                    "./myformula/high/不等式/常用不等式1.mml",
                    "./myformula/high/不等式/常用不等式2.mml",
                    "./myformula/high/不等式/常用不等式3.mml",
                    "./myformula/high/不等式/常用不等式4.mml",
                    "./myformula/high/不等式/常用不等式5.mml",
                    "./myformula/high/不等式/含有绝对值的不等式.mml",
                    "./myformula/high/不等式/均值不等式.mml",
                    "./myformula/high/不等式/均值不等式-几何平均数.mml",
                    "./myformula/high/不等式/均值不等式-平方平均数.mml",
                    "./myformula/high/不等式/均值不等式-算数平均数.mml",
                    "./myformula/high/不等式/均值不等式-调和平均数.mml",
                    "./myformula/high/不等式/三角不等式1.mml",
                    "./myformula/high/不等式/三角不等式2.mml",
                    "./myformula/high/不等式/三角不等式3.mml",
                    "./myformula/high/不等式/一元二次不等式.mml",
                ],
                [
                    "./myformula/high/初等函数/常用对数、自然对数之间的关系.mml",
                    "./myformula/high/初等函数/常用对数.mml",
                    "./myformula/high/初等函数/对数函数定义、对数恒等式.mml",
                    "./myformula/high/初等函数/对数函数定义.mml",
                    "./myformula/high/初等函数/对数恒等式.mml",
                    "./myformula/high/初等函数/对数换底公式-1.mml",
                    "./myformula/high/初等函数/对数换底公式-2.mml",
                    "./myformula/high/初等函数/对数运算法则.mml",
                    "./myformula/high/初等函数/反函数的定义.mml",
                    "./myformula/high/初等函数/反函数的性质1.mml",
                    "./myformula/high/初等函数/反函数的性质2.mml",
                    "./myformula/high/初等函数/反函数的性质3.mml",
                    "./myformula/high/初等函数/反函数的性质4.mml",
                    "./myformula/high/初等函数/分式的指数.mml",
                    "./myformula/high/初等函数/负数指数.mml",
                    "./myformula/high/初等函数/幂函数-定义.mml",
                    "./myformula/high/初等函数/指数的乘法.mml",
                    "./myformula/high/初等函数/指数的乘方.mml",
                    "./myformula/high/初等函数/指数的除法.mml",
                    "./myformula/high/初等函数/指数的开方.mml",
                    "./myformula/high/初等函数/指数函数定义、自然指数函数.mml",
                    "./myformula/high/初等函数/指数为零.mml",
                    "./myformula/high/初等函数/自然对数.mml",
                ],
                [
                    "./myformula/high/导数/导数的定义.mml",
                    "./myformula/high/导数/导数的记法.mml",
                    "./myformula/high/导数/导数的莱布尼兹记法.mml",
                    "./myformula/high/导数/导数的牛顿记法.mml",
                    "./myformula/high/导数/反函数求导法则.mml",
                    "./myformula/high/导数/复合函数求导法则.mml",
                    "./myformula/high/导数/和差积商求导法则.mml",
                    "./myformula/high/导数/基本导数-1.mml",
                    "./myformula/high/导数/基本导数-2.mml",
                    "./myformula/high/导数/基本导数-3.mml",
                    "./myformula/high/导数/基本导数-4.mml",
                ],
                [
                    "./myformula/high/方程/卡尔丹公式.mml",
                    "./myformula/high/方程/双曲线的标准方程.mml",
                    "./myformula/high/方程/椭圆的标准方程.mml",
                    "./myformula/high/方程/椭圆的参数方程.mml",
                    "./myformula/high/方程/椭圆的切线方程1.mml",
                    "./myformula/high/方程/椭圆的切线方程2.mml",
                    "./myformula/high/方程/椭圆的切线方程3.mml",
                    "./myformula/high/方程/一元三次方程.mml",
                    "./myformula/high/方程/圆的参数方程.mml",
                    "./myformula/high/方程/圆的直径式方程.mml",
                    "./myformula/high/方程/直线方程--点斜式.mml",
                    "./myformula/high/方程/直线方程--截距式.mml",
                    "./myformula/high/方程/直线方程--两点式.mml",
                    "./myformula/high/方程/直线方程--两点式的推广.mml",
                    "./myformula/high/方程/直线方程--斜截式.mml",
                    "./myformula/high/方程/直线方程--一般式.mml",
                ],
                [
                    "./myformula/high/基础知识/n次独立重复试验的概率.mml",
                    "./myformula/high/基础知识/超几何分布.mml",
                    "./myformula/high/基础知识/独立事件.mml",
                    "./myformula/high/基础知识/二项分布.mml",
                    "./myformula/high/基础知识/方差和标准差.mml",
                    "./myformula/high/基础知识/复数--乘法.mml",
                    "./myformula/high/基础知识/复数--除法.mml",
                    "./myformula/high/基础知识/复数--纯虚数.mml",
                    "./myformula/high/基础知识/复数--定义.mml",
                    "./myformula/high/基础知识/复数--共轭复数.mml",
                    "./myformula/high/基础知识/复数--几何意义.mml",
                    "./myformula/high/基础知识/复数--加减法.mml",
                    "./myformula/high/基础知识/复数--相等.mml",
                    "./myformula/high/基础知识/复数--虚数.mml",
                    "./myformula/high/基础知识/概率--对立性质.mml",
                    "./myformula/high/基础知识/概率--互斥性质.mml",
                    "./myformula/high/基础知识/概率--基本性质.mml",
                    "./myformula/high/基础知识/概率--计算公式.mml",
                    "./myformula/high/基础知识/集合--并集.mml",
                    "./myformula/high/基础知识/集合--补集.mml",
                    "./myformula/high/基础知识/集合--集合相等的定义.mml",
                    "./myformula/high/基础知识/集合--交集.mml",
                    "./myformula/high/基础知识/集合--运算1.mml",
                    "./myformula/high/基础知识/集合--运算2.mml",
                    "./myformula/high/基础知识/集合--运算3.mml",
                    "./myformula/high/基础知识/集合--真子集的定义.mml",
                    "./myformula/high/基础知识/集合--子集的定义.mml",
                    "./myformula/high/基础知识/逻辑用语--必要条件.mml",
                    "./myformula/high/基础知识/逻辑用语--充分条件.mml",
                    "./myformula/high/基础知识/逻辑用语--充要条件.mml",
                    "./myformula/high/基础知识/逻辑用语--逻辑非.mml",
                    "./myformula/high/基础知识/逻辑用语--逻辑或.mml",
                    "./myformula/high/基础知识/逻辑用语--逻辑且.mml",
                    "./myformula/high/基础知识/逻辑用语--四种命题.mml",
                    "./myformula/high/基础知识/数集.mml",
                    "./myformula/high/基础知识/数学期望.mml",
                    "./myformula/high/基础知识/随机变量及其分布列性质.mml",
                    "./myformula/high/基础知识/条件概率.mml",
                    "./myformula/high/基础知识/条件概率--性质.mml",
                    "./myformula/high/基础知识/正态分布.mml",
                ],
                [
                    "./myformula/high/数列/常数项级数-定义.mml",
                    "./myformula/high/数列/等比级数.mml",
                    "./myformula/high/数列/等比数列--常用性质1.mml",
                    "./myformula/high/数列/等比数列--常用性质2.mml",
                    "./myformula/high/数列/等比数列--求和公式.mml",
                    "./myformula/high/数列/等比数列--通项公式1.mml",
                    "./myformula/high/数列/等比数列--通项公式1.mml",
                    "./myformula/high/数列/等差数列-常用性质1.mml",
                    "./myformula/high/数列/等差数列-常用性质2.mml",
                    "./myformula/high/数列/等差数列-常用性质3.mml",
                    "./myformula/high/数列/等差数列-常用性质4.mml",
                    "./myformula/high/数列/等差数列-求和公式1.mml",
                    "./myformula/high/数列/等差数列-求和公式2.mml",
                    "./myformula/high/数列/等差数列-通项公式1.mml",
                    "./myformula/high/数列/等差数列-通项公式1.mml",
                    "./myformula/high/数列/阶乘的定义.mml",
                    "./myformula/high/数列/全排列和选排列.mml",
                    "./myformula/high/数列/数列常用裂项方法1.mml",
                    "./myformula/high/数列/数列常用裂项方法2.mml",
                    "./myformula/high/数列/数列常用裂项方法3.mml",
                    "./myformula/high/数列/数列常用裂项方法4.mml",
                    "./myformula/high/数列/数列常用裂项方法5.mml",
                    "./myformula/high/数列/数列常用裂项方法6.mml",
                    "./myformula/high/数列/数列的求和公式1.mml",
                    "./myformula/high/数列/数列的求和公式2.mml",
                    "./myformula/high/数列/数列的通项公式.mml",
                    "./myformula/high/数列/组合.mml",
                    "./myformula/high/数列/组合公式.mml",
                ],
                [
                    "./myformula/high/图形几何/两直线平行.mml",
                    "./myformula/high/图形几何/面面垂直判定定理.mml",
                    "./myformula/high/图形几何/面面垂直性质定理.mml",
                    "./myformula/high/图形几何/面面平行判定定理.mml",
                    "./myformula/high/图形几何/面面平行性质定理.mml",
                    "./myformula/high/图形几何/判断直线在平面内.mml",
                    "./myformula/high/图形几何/确定两平面的交线.mml",
                    "./myformula/high/图形几何/确定平面.mml",
                    "./myformula/high/图形几何/线面垂直判定定理.mml",
                    "./myformula/high/图形几何/线面垂直性质定理.mml",
                    "./myformula/high/图形几何/线面平行判定定理.mml",
                    "./myformula/high/图形几何/线面平行性质定理.mml",
                ],
                [
                    "./myformula/high/向量/空间向量--点面距.mml",
                    "./myformula/high/向量/空间向量--点线距.mml",
                    "./myformula/high/向量/空间向量--共面定理.mml",
                    "./myformula/high/向量/空间向量--共线定理.mml",
                    "./myformula/high/向量/空间向量--基本定理.mml",
                    "./myformula/high/向量/空间向量--两面角.mml",
                    "./myformula/high/向量/空间向量--线面角.mml",
                    "./myformula/high/向量/空间向量--线线角.mml",
                    "./myformula/high/向量/两向量的夹角公式.mml",
                    "./myformula/high/向量/实数与向量的积运算律--第二分配律.mml",
                    "./myformula/high/向量/实数与向量的积运算律--第一分配律.mml",
                    "./myformula/high/向量/实数与向量的积运算律--结合律.mml",
                    "./myformula/high/向量/向量垂直.mml",
                    "./myformula/high/向量/向量的模.mml",
                    "./myformula/high/向量/向量的数量积.mml",
                    "./myformula/high/向量/向量的坐标运算--加法.mml",
                    "./myformula/high/向量/向量的坐标运算--减法.mml",
                    "./myformula/high/向量/向量的坐标运算--数量积.mml",
                    "./myformula/high/向量/向量的坐标运算--与实数的积.mml",
                    "./myformula/high/向量/向量平行.mml",
                    "./myformula/high/向量/向量数量积运算的主要性质1.mml",
                    "./myformula/high/向量/向量数量积运算的主要性质2.mml",
                ],
                [
                    "./myformula/university/常微分方程/伯努利方程.mml",
                    "./myformula/university/常微分方程/初值问题.mml",
                    "./myformula/university/常微分方程/第二类可化为变量分离微分方程.mml",
                    "./myformula/university/常微分方程/第一类可化为变量分离微分方程.mml",
                    "./myformula/university/常微分方程/二阶常系数非齐次线性微分方程.mml",
                    "./myformula/university/常微分方程/二阶常系数齐次线性微分方程.mml",
                    "./myformula/university/常微分方程/全微分方程.mml",
                    "./myformula/university/常微分方程/微分形式变量可分离方程.mml",
                    "./myformula/university/常微分方程/微分形式一阶方程、通解.mml",
                    "./myformula/university/常微分方程/显示变量可分离方程.mml",
                    "./myformula/university/常微分方程/显示方程.mml",
                    "./myformula/university/常微分方程/一阶线性非齐次微分方程.mml",
                    "./myformula/university/常微分方程/一阶线性齐次微分方程.mml",
                    "./myformula/university/常微分方程/隐式方程.mml",
                ],
                ["./myformula/university/有理函数/有理函数多项式.mml", "./myformula/university/有理函数/有理整函数多项式.mml"],
                [
                    "./myformula/university/代数/伯努利不等式.mml",
                    "./myformula/university/代数/不等式-1.mml",
                    "./myformula/university/代数/不等式-2.mml",
                    "./myformula/university/代数/多项式定理.mml",
                    "./myformula/university/代数/二项式定理.mml",
                    "./myformula/university/代数/赫尔德不等式.mml",
                    "./myformula/university/代数/阶乘有限和公式.mml",
                    "./myformula/university/代数/柯西不等式.mml",
                    "./myformula/university/代数/闵科夫斯基不等式.mml",
                    "./myformula/university/代数/切比雪夫不等式.mml",
                    "./myformula/university/代数/三角形不等式.mml",
                    "./myformula/university/代数/斯特林公式.mml",
                    "./myformula/university/代数/算术平均值不大于均方根.mml",
                    "./myformula/university/代数/詹森不等式.mml",
                    "./myformula/university/代数/正数的几何平均值不大于算数平均值.mml",
                    "./myformula/university/代数/正数加权平均值不等关系.mml",
                ],
                [
                    "./myformula/university/微积分/不定积分 1.mml",
                    "./myformula/university/微积分/不定积分 2.mml",
                    "./myformula/university/微积分/不定积分 3.mml",
                    "./myformula/university/微积分/不定积分 4.mml",
                    "./myformula/university/微积分/不定积分 5.mml",
                    "./myformula/university/微积分/不定积分的性质.mml",
                    "./myformula/university/微积分/第一类曲线积分的性质.mml",
                    "./myformula/university/微积分/定积分 1.mml",
                    "./myformula/university/微积分/定积分 2.mml",
                    "./myformula/university/微积分/定积分 3.mml",
                    "./myformula/university/微积分/定积分 4.mml",
                    "./myformula/university/微积分/定积分 5.mml",
                    "./myformula/university/微积分/定积分 6.mml",
                    "./myformula/university/微积分/定积分 7.mml",
                    "./myformula/university/微积分/定积分 8.mml",
                    "./myformula/university/微积分/定积分 9.mml",
                    "./myformula/university/微积分/定积分 10.mml",
                    "./myformula/university/微积分/对弧长的曲线积分.mml",
                    "./myformula/university/微积分/二重积分的定义、计算.mml",
                    "./myformula/university/微积分/二重积分中值定理、二重积分换元法.mml",
                    "./myformula/university/微积分/积分中值定理及其推广第一定理.mml",
                    "./myformula/university/微积分/积分中值定理推广第二定理.mml",
                    "./myformula/university/微积分/极限.mml",
                    "./myformula/university/微积分/洛必达法则-1.mml",
                    "./myformula/university/微积分/洛必达法则-2.mml",
                    "./myformula/university/微积分/牛顿-莱布尼兹公式.mml",
                    "./myformula/university/微积分/三重积分的定义、计算.mml",
                    "./myformula/university/微积分/泰勒公式、拉格朗日余项.mml",
                    "./myformula/university/微积分/微分法则.mml",
                    "./myformula/university/微积分/微分形式不变性.mml",
                    "./myformula/university/微积分/重积分性质 1.mml",
                    "./myformula/university/微积分/重积分性质 2.mml",
                    "./myformula/university/微积分/重积分性质 3.mml",
                    "./myformula/university/微积分/重积分性质 4.mml",
                    "./myformula/university/微积分/重积分性质 5.mml",
                ],
                [
                    "./myformula/university/无穷级数/常用幂级数展开.mml",
                    "./myformula/university/无穷级数/二项式展开.mml",
                    "./myformula/university/无穷级数/傅里叶级数.mml",
                    "./myformula/university/无穷级数/幂级数-定义.mml",
                    "./myformula/university/无穷级数/欧拉公式.mml",
                    "./myformula/university/无穷级数/三角级数、三角函数的正交性.mml",
                    "./myformula/university/无穷级数/三角级数-简谐振动.mml",
                    "./myformula/university/无穷级数/泰勒级数、麦克劳林级数.mml",
                    "./myformula/university/无穷级数/正弦、余弦级数，傅里叶级数的复数形式.mml",
                ],
                [
                    "./myformula/university/概率论/贝叶斯公式.mml",
                    "./myformula/university/概率论/超几何概率分布.mml",
                    "./myformula/university/概率论/独立性定理.mml",
                    "./myformula/university/概率论/概率的乘法公式.mml",
                    "./myformula/university/概率论/概率基本性质-1.mml",
                    "./myformula/university/概率论/概率基本性质-2.mml",
                    "./myformula/university/概率论/概率基本性质-3.mml",
                    "./myformula/university/概率论/概率性质-1.mml",
                    "./myformula/university/概率论/概率性质-2.mml",
                    "./myformula/university/概率论/概率性质-3.mml",
                    "./myformula/university/概率论/概率性质-4.mml",
                    "./myformula/university/概率论/概率与频率的关系.mml",
                    "./myformula/university/概率论/古典概型.mml",
                    "./myformula/university/概率论/频率的定义.mml",
                    "./myformula/university/概率论/频率性质-1.mml",
                    "./myformula/university/概率论/频率性质-2.mml",
                    "./myformula/university/概率论/频率性质-3.mml",
                    "./myformula/university/概率论/全概率公式.mml",
                    "./myformula/university/概率论/三事件互相独立.mml",
                    "./myformula/university/概率论/条件概率.mml",
                ],
                [
                    "./myformula/university/线性代数/m行n列矩阵.mml",
                    "./myformula/university/线性代数/n阶方阵.mml",
                    "./myformula/university/线性代数/乘法.mml",
                    "./myformula/university/线性代数/对称矩阵、反对称矩阵.mml",
                    "./myformula/university/线性代数/对角阵.mml",
                    "./myformula/university/线性代数/加法.mml",
                    "./myformula/university/线性代数/零阵.mml",
                    "./myformula/university/线性代数/数乘.mml",
                    "./myformula/university/线性代数/线性变化.mml",
                    "./myformula/university/线性代数/线性代数方程组.mml",
                    "./myformula/university/线性代数/运算法则.mml",
                    "./myformula/university/线性代数/转置.mml",
                ],
                // [
                // 	"./myformula/custom/customformula1/myformula_1.mml",
                // 	"./myformula/custom/customformula1/myformula_2.mml",
                // 	"./myformula/custom/customformula1/myformula_3.mml",
                // 	"./myformula/custom/customformula1/myformula_4.mml",
                // 	"./myformula/custom/customformula1/myformula_5.mml",
                // 	"./myformula/custom/customformula1/请输入公式名.mml"
                // ],
                // [
                // 	"./myformula/custom/customformula2/myformula_1.mml",
                // 	"./myformula/custom/customformula2/myformula_2.mml",
                // 	"./myformula/custom/customformula2/myformula_3.mml",
                // 	"./myformula/custom/customformula2/myformula_4.mml",
                // 	"./myformula/custom/customformula2/myformula_5.mml",
                // 	"./myformula/custom/customformula2/myformula_6.mml",
                // 	"./myformula/custom/customformula2/myformula_7.mml"
                // ],
                // [
                // 	"./myformula/custom/customformula3/myformula_1.mml",
                // 	"./myformula/custom/customformula3/myformula_2.mml",
                // 	"./myformula/custom/customformula3/myformula_3.mml",
                // 	"./myformula/custom/customformula3/myformula_4.mml",
                // 	"./myformula/custom/customformula3/myformula_5.mml"
                // ],
                // [
                // 	"./myformula/custom/customformula4/myformula_1.mml",
                // 	"./myformula/custom/customformula4/myformula_2.mml",
                // 	"./myformula/custom/customformula4/myformula_3.mml",
                // 	"./myformula/custom/customformula4/myformula_4.mml",
                // 	"./myformula/custom/customformula4/myformula_5.mml"
                // ],
                // [
                // 	"./myformula/custom/customformula5/myformula_1.mml",
                // 	"./myformula/custom/customformula5/myformula_2.mml",
                // 	"./myformula/custom/customformula5/myformula_3.mml",
                // 	"./myformula/custom/customformula5/myformula_4.mml",
                // 	"./myformula/custom/customformula5/myformula_5.mml",
                // 	"./myformula/custom/customformula5/myformula_6.mml"
                // ],
                // [
                // 	"./myformula/custom/customformula6/myformulas_1.mml",
                // 	"./myformula/custom/customformula6/myformula_2.mml",
                // 	"./myformula/custom/customformula6/myformula_3.mml",
                // 	"./myformula/custom/customformula6/myformula_4.mml",
                // 	"./myformula/custom/customformula6/myformula_5.mml",
                // 	"./myformula/custom/customformula6/myformula_6.mml"
                // ]
            ],
        };
    },
    computed: {},
    methods: {},
};
